module.exports = __webpack_public_path__ + "static/scale-model-of-historic-carousel-in-seattle-washington-5f297c587391f06c8cb810e93ffc0c58.png";